export class ResponseDto<T> {
    body: T
    headers: Map<string, any>
    statusCode: string
    statusCodeValue?: number
}

export function instanceOfResponseDto(object: any): object is ResponseDto<any> {
    return object && typeof object === 'object' && 'body' in object && 'headers' in object && 'statusCode' in object
}

